var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"columns is-mobile is-vcentered has-text-centered"},[_c('div',{staticClass:"column"},[_c('p',[_vm._v("\n        Powered by "),_c('a',{attrs:{"href":"http://updivision.com/"}},[_vm._v("UPDIVISION")])])])])])
}]

export { render, staticRenderFns }